import React from "react";
import banner from "../../images/location_search--.png";
import {
	MdWarning,
	MdArrowForward,
	MdSupportAgent,
	MdApartment,
	MdHouse,
	MdSchool,
	MdHelpOutline,
} from "react-icons/md";
import { Link } from "react-router-dom";

const quickLinks = [
	{ to: "/hostels", label: "Hostels", icon: <MdApartment /> },
	{ to: "/homestels", label: "Homestels", icon: <MdHouse /> },
	{ to: "/obuasi-campus", label: "Obuasi Campus", icon: <MdSchool /> },
	{ to: "/faqs", label: "FAQs", icon: <MdHelpOutline /> },
];

export default function Banner(props) {
	return (
		<section className="lp-hero">
			<div className="container">
				<div className="lp-hero-grid">
					<div className="lp-hero-text">
						<span className="lp-eyebrow">KOSASS</span>
						<h1 className="lp-hero-title">
							KNUST Off-Campus Students&apos; Accommodation Support System
						</h1>
						<p className="lp-hero-sub">
							Access All Recognised Private Hostels &amp; Homestels
						</p>
						<p className="lp-hero-body">
							Access the University&apos;s recognised private Hostels and Homestels
							for easy room booking and get all necessary information concerning
							them.
						</p>
						<div className="lp-hero-actions">
							<Link to="/hostels" className="lp-btn lp-btn--primary">
								Browse Hostels <MdArrowForward />
							</Link>
							<Link to="/help-desk" className="lp-btn lp-btn--ghost">
								<MdSupportAgent /> Get Help
							</Link>
						</div>
						<nav className="lp-quick" aria-label="Quick links">
							{quickLinks.map((item) => (
								<Link key={item.to} to={item.to} className="lp-quick-link">
									{item.icon} {item.label}
								</Link>
							))}
						</nav>
					</div>

					<div className="lp-hero-art">
						<div className="lp-hero-blob" aria-hidden="true" />
						<img src={banner} alt="Locating residences on a map" className="lp-hero-img" />
					</div>
				</div>

				<aside className="lp-warning" role="note">
					<div className="lp-warning-icon">
						<MdWarning />
					</div>
					<div>
						<h2 className="lp-warning-title">Room Booking Warning</h2>
						<p className="lp-warning-text">
							Payment for bed spaces should only be made into official{" "}
							<b>Bank Account</b> of Hostels or Homestels. Any student who pays cash
							through <b>Unauthorized or Unofficial Bank Account / Momo Accounts</b>{" "}
							does so at his or her own risk. Students <b>MUST</b> check available
							facilities of the hostels and confirm their interest before making
							payments.
						</p>
					</div>
				</aside>
			</div>
		</section>
	);
}
